<template>
    <li :class="{active: (media.id == viewMediaId)}">
        <a href="#//" @click="$emit('select-media', media.id)">
            <div class="thumb">
                <img
                    :src="media.thumbnail"
                    :alt="media.title+' 이미지 입니다.'"
                >
                <span class="source-origin" v-show="media.copyright!='한국문화원연합회'">사진출처: {{media.copyright}}</span>
            </div>
            <div class="data-wrap">
                <strong class="title">{{media.title}}</strong>
                <ul class="asset-data-meta">
                    <li>{{media.theme_name}} &gt; {{media.child_theme_name}}</li>
                    <li class="bar">{{media.major_category_name}} &gt; {{media.minor_category_name}}</li>
                </ul>
            </div>
        </a>
    </li>
</template>

<script>
export default {
    props: {
        viewMediaId: { type: Number }, // 팝업에서 보여지고 있는 미디어
        media: { type: Object }, // 미디어 정보 객체
    },
}
</script>